/* ============================================================
   Mini-cart: close on outside click, and stop the flashing.
   ------------------------------------------------------------
   Two faults this fixes.

   1. THE BLINK. cart.css ships

        .cart_shipping_free.cart_shipping * {
          animation: flash 0.8s linear 0.8s 2 both;
        }

      and @keyframes flash runs opacity 1 -> 0 -> 1 -> 0 -> 1.
      Applied through `*` it hits every descendant of the free
      shipping bar. CSS alone could not settle it because the
      theme re-adds `cart_shipping_free` on every cart re-render
      (adding an item, changing a quantity), which restarts the
      animation on the fresh nodes. The class is stripped here as
      it appears, so the state it carries is expressed by the
      progress bar's width instead of by blinking.

   2. NO OUTSIDE-CLICK CLOSE. theme.min.js binds a handler to
      .bls__overlay that removes hside_opened, bls__opend-popup
      and addons-open. When the pointer lands on the part of the
      page NOT covered by that overlay element, or when the
      overlay has already been hidden by another handler, nothing
      closes the drawer — it stays open with no dimmed backdrop,
      which is what made the page look like it was flickering
      between states. A document-level listener closes the drawer
      on any click outside it, including Escape.
   ============================================================ */

(function () {
  'use strict';

  var DRAWER = '.bls-minicart-wrapper';
  /* The theme opens the mini-cart by putting bls__opend-popup-HEADER
     on .header_minicart — not bls__opend-popup, which is what other
     drawers use. Looking only for the latter meant closeDrawer()
     stripped a class that was never set, so the X removed nothing and
     the drawer stayed on screen. Both spellings are handled. */
  var OPEN_HOST = '.bls__opend-popup, .bls__opend-popup-header';
  var OPEN_CLASSES = ['bls__opend-popup', 'bls__opend-popup-header'];
  var OVERLAY = '.bls__overlay';

  /* ---- 1. Keep the flashing class off ---------------------- */

  function stripFlash(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var flashing = scope.querySelectorAll('.cart_shipping_free');
    for (var i = 0; i < flashing.length; i++) {
      flashing[i].classList.remove('cart_shipping_free');
    }
  }

  stripFlash(document);

  // The cart re-renders on add / quantity change, and the theme puts
  // the class back on the new markup. Watching the subtree catches it
  // the moment it returns rather than only on first paint.
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes') {
          if (r.target.classList && r.target.classList.contains('cart_shipping_free')) {
            r.target.classList.remove('cart_shipping_free');
          }
        } else {
          for (var j = 0; j < r.addedNodes.length; j++) {
            var n = r.addedNodes[j];
            if (n.nodeType === 1) stripFlash(n);
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  /* ---- 2. Close the drawer on an outside click ------------- */

  function drawerIsOpen() {
    var drawer = document.querySelector(DRAWER);
    if (!drawer) return false;
    // The canvas is shown by .bls__opend-popup on an ancestor; checking
    // the computed visibility also covers any other route the theme
    // might use to open it.
    if (drawer.closest(OPEN_HOST)) return true;
    return window.getComputedStyle(drawer).visibility === 'visible';
  }

  function closeDrawer() {
    var hosts = document.querySelectorAll(OPEN_HOST);
    for (var i = 0; i < hosts.length; i++) {
      for (var j = 0; j < OPEN_CLASSES.length; j++) {
        hosts[i].classList.remove(OPEN_CLASSES[j]);
      }
    }

    var overlay = document.querySelector(OVERLAY);
    if (overlay) overlay.classList.add('d-none-overlay');

    document.documentElement.classList.remove('hside_opened');
    document.documentElement.classList.remove('vetical-overlay');

    var wrappers = document.querySelectorAll(DRAWER);
    for (var k = 0; k < wrappers.length; k++) {
      wrappers[k].classList.remove('addons-open');
    }

    var active = document.querySelectorAll('.header_minicart.active');
    for (var m = 0; m < active.length; m++) {
      active[m].classList.remove('active');
    }
  }

  /* ---- 3. Mark the document while the drawer is open -------
     CSS hides the bottom stickybar while the cart is open, so the
     checkout button is not covered. The theme sets .hside_opened
     on <html> for its own drawers but not reliably for this one,
     and :has() is not supported everywhere, so a class is set
     here as the dependable signal. */

  function syncOpenState() {
    var open = drawerIsOpen();
    document.documentElement.classList.toggle('deshio-cart-open', open);
  }

  if (window.MutationObserver) {
    var stateWatcher = new MutationObserver(syncOpenState);
    stateWatcher.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // A single 60ms sample is taken while the drawer is still mid-
  // transition: the close animation runs ~400ms, so the drawer is
  // still visible at 60ms and the open state latches ON and never
  // clears — leaving the page inert after the cart is closed.
  // Sampled again across the whole transition instead.
  function syncSoon() {
    [60, 200, 400, 650].forEach(function (ms) {
      setTimeout(syncOpenState, ms);
    });
  }

  document.addEventListener('click', syncSoon, true);

  // The drawer slides on a transform; when that finishes the state is
  // final, whatever route opened or closed it.
  var drawerEl = document.querySelector(DRAWER);
  if (drawerEl) {
    drawerEl.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'transform' || e.propertyName === 'visibility') {
        /* The drawer's own close button is not bound by the theme:
     theme.min.js only wires .button-close inside .mini_search_header.
     Until now the drawer closed because a click landed on the overlay
     behind it; once the drawer was correctly raised above the overlay
     that route disappeared and the X did nothing. Bound here.

     Delegated, because the drawer markup is replaced on every cart
     re-render and a direct listener would be lost with it. */
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var closer = t.closest(DRAWER + ' .button-close, ' + DRAWER + ' .close-button');
    if (!closer) return;

    // The close button lives inside .header_minicart, which is also the
    // cart TOGGLE. Every other click handler - the theme's and the
    // outside-click one below - treats anything in that container as
    // 'the control that opens the cart' and ignores it, so the X was
    // skipped by all of them. Stopping propagation here is what keeps
    // the toggle from seeing this click and re-opening the drawer.
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    closeDrawer();
    syncSoon();
  }, true);

  syncOpenState();
      }
    });
  }

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') syncSoon();
  });

  syncOpenState();

  document.addEventListener(
    'click',
    function (event) {
      if (!drawerIsOpen()) return;

      var t = event.target;

      // Inside the drawer: leave it alone.
      if (t.closest && t.closest(DRAWER)) return;

      // The control that opens the cart toggles itself; letting this
      // handler also fire would close and immediately reopen.
      if (t.closest && t.closest('.bls-minicart-action, .header_minicart, [data-cart-toggle]')) return;

      closeDrawer();
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawerIsOpen()) closeDrawer();
  });
})();
